import Chart from "react-apexcharts";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { Stack } from "@bookingcom/bui-react";
import { ChartHeader } from "../ChartHeader";
import { ChartYaxisTitle } from "../ChartYaxisTitle";
import { useDiscountedBookingsChartController } from "./DiscountedBookingsChart.controller";
import type { Metric } from "../../../types";
import { CHART_HEIGHT } from "../ChartConstants";
import "../Charts.css";

export type DiscountedBookingsSeries = { airlineCode?: string; airlineName?: string; metric: Metric };

export type DiscountedBookingsChartProps = { series: DiscountedBookingsSeries[] };

export const DiscountedBookingsChart = ({ series }: DiscountedBookingsChartProps) => {
  const i18n = useI18n();
  const {
    totalBookings,
    options,
    series: chartSeries,
    chartType,
    isSingleSeries,
  } = useDiscountedBookingsChartController({ series });

  return (
    <Stack gap={isSingleSeries ? 0 : 4}>
      <ChartHeader
        titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_name"))}
        titleTooltipText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_tooltip"))}
        subtitleText={i18n.trans(
          t("flights_airline_portal_realtime_performance_metric_one_subheader", {
            variables: { num_bookings: totalBookings },
          })
        )}
        subtitleValue={totalBookings.toString()}
      />
      <Stack mixin={{ position: "relative" }}>
        <ChartYaxisTitle titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_yaxis"))} />
        <Chart options={options} series={chartSeries} type={chartType} height={CHART_HEIGHT} />
      </Stack>
    </Stack>
  );
};
